import React from "react";
import { Form } from "react-bootstrap";
import { connect,useDispatch } from "react-redux";
import { 
    BOT_SUBSCRIPTION_MONTHLY,
    BOT_SUBSCRIPTION_QUARTERLY,
    BOT_SUBSCRIPTION_HALFYEARLY ,
    BOT_SUBSCRIPTION_ANNUAL,
    BOT_SUBSCRIPTION_ONETIME,
    BOT_TEMPLATE_DESCRIPTION,
    BOT_TEMPLATE_TITLE
} from "../../../actions/types";
import { restrictAlphabets } from "../../../utils/Utils";


const BotSubmitDescriptionView = (props)=>{
    const {bot,t} = props
    const monthlyRental = bot.frequency==5?'19.99':'9.99'
    const quarterlyRental = bot.frequency==5?'59.99':'29.99'
    const yearlyRental = bot.frequency==5?'199.99':'99.99'
    const dispatch = useDispatch()
    const botTitleChanged = (val)=>{
        dispatch({
            type: BOT_TEMPLATE_TITLE,
            payload: val,
        });
    }
    const botDescriptionChanged = (val)=>{
        dispatch({
            type: BOT_TEMPLATE_DESCRIPTION,
            payload: val,
        });
    }
    const botSubscriptionFeeChanged = (val,type)=>{
        dispatch({
            type: type,
            payload: val,
        });
    }
    return (
        <>
            <Form>
                <Form.Control type="text" placeholder={t("bt")}  className="mt-3" onChange={(e)=>botTitleChanged(e.target.value)}/>
                <Form.Control as="textarea" rows={3} placeholder={t("bot-desc")} className="mt-3" onChange={(e)=>botDescriptionChanged(e.target.value)} maxLength="500"/>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>{t("m-sub-fee")}: US$</Form.Label>
                    <Form.Control type="number" placeholder={`(Minimum is US$${monthlyRental})`} onChange={(e)=>botSubscriptionFeeChanged(e.target.value,BOT_SUBSCRIPTION_MONTHLY)} onKeyPress={(e) => {
                        restrictAlphabets(e);
                      }}/>
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>{t("q-sub-fee")}: US$</Form.Label>
                    <Form.Control type="number" placeholder={`(Minimum is US$${quarterlyRental})`} onChange={(e)=>botSubscriptionFeeChanged(e.target.value,BOT_SUBSCRIPTION_QUARTERLY)} onKeyPress={(e) => {
                        restrictAlphabets(e);
                      }}/>
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>{t("a-sub-fee")}: US$</Form.Label>
                    <Form.Control type="number" placeholder={`(Minimum is US$${yearlyRental})`} onChange={(e)=>botSubscriptionFeeChanged(e.target.value,BOT_SUBSCRIPTION_ANNUAL)} onKeyPress={(e) => {
                        restrictAlphabets(e);
                      }}/>
                </Form.Group>
                
            </Form>
        </>
    );
}
export default connect (null,{})(BotSubmitDescriptionView)